import React from 'react';
import IconName from "../../svgLogo/SvgLogo";

const Bundle = ({theme}) => {
    return (
        <div className={`bundle-product-wrapper ${theme}`}>
            <div className="container container-xl-small">
                <div className="title xmb-6 d-block d-lg-none title-bundle-page">
                    <div className="title-box just-text title-box-blue">
                        <div className="title-bg">
                            <h2 className="text">
                                باندل
                            </h2>
                        </div>
                    </div>
                </div>
                <div className="bundle-product-box position-relative xp-6">
                    <div className="title-price xmb-6 d-none d-lg-flex justify-content-between align-items-center">
                        <h2 className="title">گوشی موبایل اپل مدل iPhone 11 A2223 دو سیم‌ کارت ظرفیت 128 گیگابایت</h2>
                        <div className="buuton-price">
                            <a href="#" className="total-price persian-number"><IconName name="library_add"
                                                                                         className="icon"/>۱۴،۹۸۹،۰۰۰
                                ت</a>
                        </div>
                    </div>
                    <div
                        className="price-box-product-responsive d-flex d-lg-none justify-content-between align-items-center position-absolute">
                        <div className="discount persian-number">۲۱،۱۱۵،۰۰۰ ت</div>
                        <div className="total-price persian-number">۱۴،۹۸۹،۰۰۰ ت</div>
                    </div>
                    <div className="products-bundle">
                        <div className="row">
                            <div className="col-lg-3">
                                <div className="big-product d-flex justify-content-center align-items-center">
                                    <img
                                        src="./assets/sample-image/apple-iphone-5.png"
                                        alt="21"/>
                                    <div className="title-product-responsive d-block d-lg-none">
                                        <h2 className="title">
                                            گوشی موبایل اپل مدل iPhone 11 A2223 دو سیم‌ کارت ظرفیت 128 گیگابایت
                                        </h2>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-9">
                                <div className="other-products">
                                    <ul className="list-unstyled">
                                        <li className="list-product">
                                            <div
                                                className="d-block d-lg-flex justify-content-lg-between align-items-center">
                                                <div className="info-product d-flex">
                                                    <img src=" ./assets/sample-image/MXYN-4.png" alt="aa"/>
                                                    <div className="name-product">
                                                        <h3 className="name">کاور سیلیکونی آیفون ۱۱</h3>
                                                        <span className="discount persian-number">۲۵٪ تخفیف</span>
                                                    </div>
                                                </div>
                                                <div className="total-price-product">
                                                            <span
                                                                className="total-price persian-number">499,000 ت</span>
                                                    <span className="discount persian-number">۶۷۵،۰۰۰ ت</span>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="list-product">
                                            <div
                                                className="d-block d-lg-flex justify-content-between align-items-center">
                                                <div className="info-product d-flex">
                                                    <img src=" ./assets/sample-image/MWP22.png" alt="aa"/>
                                                    <div className="name-product">
                                                        <h3 className="name">هدفون بی سیم اپل ایرپاد پرو</h3>
                                                        <span className="discount persian-number">۲۵٪ تخفیف</span>
                                                    </div>
                                                </div>
                                                <div className="total-price-product">
                                                    <span className="total-price persian-number">499,000 ت</span>
                                                    <span className="discount persian-number">۶۷۵،۰۰۰ ت</span>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="list-product">
                                            <div
                                                className="d-block d-lg-flex justify-content-between align-items-center">
                                                <div className="info-product d-flex">
                                                    <img src=" ./assets/sample-image/HN6K2.png" alt="aa"/>
                                                    <div className="name-product">
                                                        <h3 className="name">Belkin BOOST CHARGE Wireless Charging
                                                            Stand</h3>
                                                        <span className="discount persian-number">30٪ تخفیف</span>
                                                    </div>
                                                </div>
                                                <div className="total-price-product">
                                                            <span
                                                                className="total-price persian-number">499,000 ت</span>
                                                    <span className="discount persian-number">۶۷۵،۰۰۰ ت</span>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="button-buy-bundle d-block d-lg-none">
                        <div className="button-bundle">
                            <IconName name="library_add" className="icon"/>
                            <span className="text persian-number">خرید ۴۴،۸۴۷،۰۰۰ ت</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Bundle;
